// Firebase init — same project as the mobile app.
// The web app uses the modular SDK v10 (tree-shakable, ~30 KB gzipped).
import { initializeApp } from 'firebase/app';
import { addDoc, collection, getFirestore, serverTimestamp } from 'firebase/firestore';
import { getAuth, signInAnonymously } from 'firebase/auth';

const firebaseConfigs = {
  nahlLens: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDq6fmoc5NT6c5weaYMIccKsQSObE8bL8Y',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'nahllens.firebaseapp.com',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'nahllens',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'nahllens.firebasestorage.app',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '49035244681',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:49035244681:web:1d241c93b3c8d0a00f0258',
  },
  waraqLens: {
    apiKey: 'AIzaSyB7pbswhgZQLlwTsyUqhj3odvO0xxoQK18',
    authDomain: 'waraqlens.firebaseapp.com',
    projectId: 'waraqlens',
    storageBucket: 'waraqlens.firebasestorage.app',
    messagingSenderId: '534652990944',
    appId: '1:534652990944:web:cbf99163c3e726006d2785',
  },
};

function productKeyForHost() {
  if (typeof window !== 'undefined' && window.location.hostname.includes('waraqlens')) {
    return 'waraqLens';
  }
  return 'nahlLens';
}

const activeProductKey = productKeyForHost();
const config = firebaseConfigs[activeProductKey];

export const app  = initializeApp(config);
export const db   = getFirestore(app);
export const auth = getAuth(app);
export const activeFirebaseProduct = activeProductKey;

/** The Command Center reads `scan_events` which requires an authenticated session. */
export async function ensureAnonAuth() {
  if (!auth.currentUser) {
    await signInAnonymously(auth);
  }
  return auth.currentUser;
}

export async function submitSupportRequest(input) {
  const user = await ensureAnonAuth();
  const payload = {
    product: activeFirebaseProduct,
    sourceHost: window.location.hostname,
    category: input.category,
    name: input.name || null,
    replyEmail: input.replyEmail || null,
    message: input.message,
    device: input.device || null,
    osVersion: input.osVersion || null,
    status: 'new',
    notificationStatus: 'not_configured',
    createdAt: serverTimestamp(),
    ownerUid: user.uid,
  };
  return addDoc(collection(db, 'support_requests'), payload);
}
